import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Hepatologist icon
 *
 * @category Medical
 */
const Hepatologist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M26.783 7.27c-.35-.74-1.29-.9-2.13-.89-1.52-.01-4.82 0-6.16 0-2.8.12-6.9-.39-9.28.41-4.01 1.48-4.48 7.06-4.29 11.19.04 1.42-.19 3.54.57 4.35.8 1.02 2.15.65 3.32.48 1.1-.16 2.35-.24 3.22-1.11.78-.6 1.01-1.88 1.89-2.28.88-.17 1.76.71 2.24 1.39.76 1.11.6 2.84.63 4.32-.06.54.22 1.98.68 1.64.71-1.06.16-3.33.39-4.71.08-2.49 1.15-4.57 2.47-5.49.95-.67 2.26-1.05 3.17-1.88 1.05-.8 1.19-1.99 1.71-3.08.58-1.21 2.23-2.74 1.62-4.2l-.06-.13zm-20.09 14.7c-1.05-.91-.71-2.48-.86-3.99-.27-4.26.32-10.369 5.01-10.609 1.41.06 4.22-.381 5.31.149.51.58.27 1.61.33 2.36-.07 2.3.16 4.36-.13 6.19-.54 2.23-3.68 1.57-5.3 2.3-1.07.44-2.013 1.404-2.722 2.304-.43.53-.858 1.376-1.518 1.336l-.11-.03zm1.633.07c-.08-.01-.111-.109-.054-.166 1.843-1.814 3.314-3.395 4.64-3.054.026.886-.983 2.018-1.696 2.512-.516.31-1.546.883-2.89.708m8.557-2.28c-.29-.2-.8-.72-1.18-.94-.19-.12-1.037-.36-.997-.45.23-.24 1.47-.234 1.981-.792.511-.557.546-.768.866-1.088.18-.14.52-.1.81-.13.32-.03.54-.02.47.11-.75.85-1.52 2.15-1.87 3.25l-.07.03zm8.93-10.84c-.59.97-1.77 1.97-1.99 3.22-.04 1.71-1.58 2.56-3.65 3.05-.82.09-2.62.75-2.76-.37.02-2.17-.15-4.74.05-6.89.1-.32.198-.539.528-.559 1.96-.1 4.732.04 6.662 0 .89-.06 1.75.319 1.24 1.399z"
        />
      </svg>
    );
  }
);

Hepatologist.displayName = 'Hepatologist';

export { Hepatologist };
